<template>
  <div class="c-calendar-components">
    <div class="loader" v-if="isLoading">
      <i class="fal fa-circle-notch fa-spin" aria-hidden="true"></i> Loading...
    </div>
    <DateNavigation
      :next-button="false"
      :previous-button="false"
      :first-instance="firstInstance"
      :last-instance="lastInstance"
      :view-type="currentView"
    />

    <FullCalendar ref="fullCalendar" :options="calendarOptions" />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import momentPlugin from "@fullcalendar/moment";
import moment from "moment";
import listPlugin from "@fullcalendar/list";
import DateNavigation from "./DateNavigation";
import { EventBus } from "../event-bus";
import axios from "axios";

export default {
  name: "Calendar",
  props: ["firstInstance", "lastInstance"],
  components: {
    FullCalendar,
    DateNavigation,
  },
  data() {
    return {
      calendarOptions: {
        firstDay: 1,
        headerToolbar: {
          start: "title",
          end: "prev,next",
        },
        dayMaxEventRows: true,
        views: {},
        footerToolbar: {
          end: "prev,next",
        },
        height: "auto",
        plugins: [listPlugin, momentPlugin],
        initialView: "listMonth",
        events: [],
        displayEventTime: false,
        eventContent: this.eventContent,
        listDayFormat: "dddd, MMMM DD",
        listDaySideFormat: false,
        fixedWeekCount: false,
        timeZone: "UTC",
        initialDate: this.firstInstance,
        validRange: this.validRange,
      },
      isLoading: true,
      allInstances: {},
      calendarApi: null,
      currentView: "listMonth",
    };
  },
  mounted() {
    this.addEventListeners();
    this.calendarApi = this.$refs.fullCalendar.getApi();
    const isJumpToMonth = this.urlParamJumpMonth();
    // This check avoids requesting for events twice on jump to month requests
    if (!isJumpToMonth) {
      this.fetchEvents();
    }
  },
  created() {
    this.currentView = "listMonth"
  },
  methods: {
    addEventListeners() {

      EventBus.$on("gotoMonth", this.gotoMonth);
      this.nextAndPreviousButtonAdditionalEvents();
    },
    eventContent(arg) {
      return {
        html: arg.event.title,
      };
    },
    fetchEvents() {
        let currentDate = moment.utc(this.calendarApi.currentData.currentDate),
            currentMonth = currentDate.format("YYYY-MM");

        if (this.allInstances.hasOwnProperty(currentMonth)) {
            this.calendarOptions.events = this.allInstances[currentMonth]
        } else {

            this.isLoading = true;
            // Otherwise, fetch the instances
            let params = this.setupQueryParams();

            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has('accessibility')) {
              params.access = urlParams.get('accessibility').split(',')
            }

            axios.get(window.wpAjax.url, {
                params: params,
            }).then((response) => {
                const instances = response.data;
                // Push our instances to the allInstances property, so we can use those next time rather than make another ajax call
                this.allInstances[currentMonth] = instances;

                // Assign the instances to our property as that is passed to the calendar
                this.calendarOptions.events = instances;
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
        }
    },
    gotoMonth(selectedMonth) {
      let month = moment(new Date(selectedMonth)).utc().startOf("month");
      this.calendarApi.gotoDate(month.format("YYYY-MM-DD"));
      this.fetchEvents();
      this.updateMonth(month.format("YYYY-MM-DD"), "gotoMonth");
    },
    nextAndPreviousButtonAdditionalEvents() {
      // previous button
      this.on("body", "click", ".fc-prev-button", (e) => {
        this.updateMonth(moment(this.calendarApi.currentData.currentDate).utc().format(), "prev");
        this.fetchEvents();
      });

      // next button
      this.on("body", "click", ".fc-next-button", (e) => {
        this.updateMonth(moment(this.calendarApi.currentData.currentDate).utc().format(), "next");
        this.fetchEvents();
      });
    },
    setupQueryParams() {
      return {
        action: "basethemeCalendarRequest",
        start: moment.utc(this.calendarApi.currentData.currentDate).format(),
        end: moment.utc(this.calendarApi.currentData.currentDate).endOf("month").format(),
      };
    },
    urlParamJumpMonth() {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has("month")) {
        const selectedMonth = urlParams.get("month");
        this.gotoMonth(selectedMonth);
        return true;
      }

      return false;
    },
    updateMonth(month, button) {
      let monthString = moment(new Date(month)).utc().startOf("month").format("YYYY-MM");
      EventBus.$emit("updateMonth", monthString, button);

      let url = new URL(window.location);
      url.searchParams.set("month", monthString);
      window.history.replaceState({}, "", url);
    },
    validRange(nowDate) {
      if (this.firstInstance && this.lastInstance) {
        return {
          start: this.firstInstance,
          end: this.lastInstance
        }
      }
      return {
        start: nowDate
      }
    },
    on(selector, eventType, childSelector, eventHandler) {
      const elements = document.querySelectorAll(selector);
      for (let element of elements) {
        element.addEventListener(eventType, (eventOnElement) => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement);
          }
        });
      }
    },
  },
};
</script>

<style lang='css'>
@import "~@fullcalendar/common/main.css";
@import "~@fullcalendar/list/main.css";
</style>
